<script setup>
import { computed } from 'vue'
import { FeatureInfo } from '@/components/feature'

const props = defineProps({
  layer: {
    type: Object,
    required: true
  }
})

const features = computed(() => {
  return props.layer?.properties?.features || []
})

</script>

<template>
  <div>
    <template v-if="features.length > 0">
      <FeatureInfo
        v-for="feature in features"
        :key="feature.uuid"
        :feature="feature"
        :show-open-in-project="true"
      />
    </template>
    <div v-else class="text-muted-foreground text-sm">
      No features in this layer.
    </div>
  </div>
</template>
